import React from "react";

export default class WalletHomePage extends React.Component {

    public static url: string = "/wallet-home";

    render() {
        return (
            <div id="wallet-home">
            </div>
        );
    }
}
